import { FocusEvent } from 'react';
import { Field, ErrorMessage, FieldProps } from 'formik';
import { Input as AntInput, Flex } from 'antd';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import { InputProps } from 'utils/globalTypes';

function Input(props: InputProps) {
  const {
    label,
    name,
    qaSelector,
    inputRef,
    showErrMsg = true,
    info,
    ...rest
  } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue } = form;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onBlur = (e: FocusEvent<HTMLInputElement>) => {
            setFieldValue(name, e.target.value.trim()).then(() => {
              field.onBlur(e);
            });
          };

          return (
            <AntInput
              status={fieldStatus}
              id={name}
              ref={inputRef}
              {...field}
              {...rest}
              onBlur={onBlur}
              data-qa-selector={qaSelector}
            />
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => <TextError msg={msg} qaSelector={`${qaSelector}-error`} />}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default Input;
